function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "65634372-75AA-4A6C-9E36-0C60F96F0012");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round"
}, /*#__PURE__*/React.createElement("g", {
  id: "text-area-form-error",
  transform: "translate(-279.000000, -40.000000)",
  fillRule: "nonzero",
  stroke: "#FF5858",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-2",
  transform: "translate(283.778175, 44.778175) rotate(-315.000000) translate(-283.778175, -44.778175) translate(278.278175, 39.278175)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0.9453125,5.58984375 L10.1816406,5.58984375",
  id: "Path-3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0.9453125,5.58984375 L10.1816406,5.58984375",
  id: "Path-3",
  transform: "translate(5.563477, 5.589844) rotate(-90.000000) translate(-5.563477, -5.589844) "
}))));

var SvgCrossMark = function SvgCrossMark(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "9px",
    height: "10px",
    viewBox: "0 0 9 10",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCrossMark, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cross-mark.2a0b3409.svg";
export { ForwardRef as ReactComponent };